import { useEffect } from 'react';
import { getItemByRef } from 'chameleon/packages/blue-book-player/utils';
import { TWO_COLUMNS_CLASS } from 'chameleon/packages/blue-book-player/constants/columns';

function useResetExpandedColumns(
  { isLearnosityApiReady, learnosityApp, playerEl },
  onReset,
) {
  useEffect(() => {
    const checkToResetExpandedColumns = (reference) => {
      const questionElement = getItemByRef(playerEl, reference);
      if (!questionElement.classList.contains(TWO_COLUMNS_CLASS)) {
        onReset();
      }
    };
    const onItemReady = () => {
      const currentItem = learnosityApp?.getCurrentItem();
      checkToResetExpandedColumns(currentItem.reference);
    };

    if (isLearnosityApiReady) {
      learnosityApp.on('item:load', onItemReady);
    }

    return () => {
      if (isLearnosityApiReady) {
        learnosityApp.off('item:load', onItemReady);
      }
    };
  }, [isLearnosityApiReady]);

  return null;
}

export default useResetExpandedColumns;
